import React from "react";
import { makeStyles } from "@material-ui/core";
import { AlertProps } from "@material-ui/lab/Alert/Alert";
import InfoIcon from "@material-ui/icons/Info";
import { tesaBlue, tesaWhite } from "../../styles/colors";

export interface CustomAlertProps extends AlertProps {
  noIcon?: boolean;
  severity?: "success" | "info" | "warning" | "error";
  text?: string;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: tesaBlue,
    color: tesaWhite,
    display: "flex",
    fontSize: "0.875rem",
    padding: "14px 10px",
  },
  icon: {
    fontSize: "2rem",
    height: "22px",
    paddingRight: "10px",
  },
});

const CustomAlert: React.FC<CustomAlertProps> = (props) => {
  const classes = useStyles(props);
  const { children, className, noIcon, text } = props;

  return (
    <div className={[classes.root, className].join(" ")}>
      {!noIcon && <InfoIcon className={classes.icon} />}
      <>{text || children}</>
    </div>
  );
};

export default CustomAlert;
